import API from './fetchAPI'

export async function fetchMetrics(days = 30) {
    return API.get('/api/metrics', { params: { days } })
}
